import BalanceCard from './BalanceCard.component';
import BudgetYearCard from './BudgetYearCard.component';
import styles from './FinanceDashboard.module.scss';
import { Props } from './FinanceDashboard.types';
import HouseAccountCard from './HouseAccountCard.component';

const FinanceDashboard = ({
  year,
  onShowUserBalance,
  onShowBankAccounts,
  onPrepareBudget,
}: Props) => {
  return (
    <div className={styles.grid}>
      <BalanceCard onShowDetail={onShowUserBalance} />
      <HouseAccountCard onShowBankAccounts={onShowBankAccounts} />
      <BudgetYearCard year={year} onPrepareBudget={onPrepareBudget} />
    </div>
  );
};

export default FinanceDashboard;
